module.exports = __webpack_public_path__ + "static/media/sfl_2.53a5eb83.jpg";